// Global Instructions Rule Applied!

import React, { forwardRef } from 'react'
import { Checkbox } from 'antd'
import { FieldValue } from '../types.ts'

export interface CheckboxInputProps {
  value: FieldValue
  onChange: (value: boolean) => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  disabled?: boolean
  checkboxLabel?: string
}

export const CheckboxInput = forwardRef<any, CheckboxInputProps>(
  ({ value, onChange, onKeyDown, disabled = false, checkboxLabel }, ref) => {
    const handleChange = (e: any) => {
      onChange(e.target.checked)
    }

    return (
      <Checkbox ref={ref} checked={Boolean(value)} onChange={handleChange} disabled={disabled}>
        {checkboxLabel}
      </Checkbox>
    )
  }
)

CheckboxInput.displayName = 'CheckboxInput'
